// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookingForm_formWrapper__SFrsR, .bookingForm_counterWrapper__Ox5kY .bookingForm_counter__ZSijr {
  align-items: center;
}

.bookingForm_counterWrapper__Ox5kY, form > button {
  margin: 0 auto;
}

.bookingForm_formWrapper__SFrsR {
  justify-content: center;
  min-height: 100vh;
}

.bookingForm_form__lxVWT {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  max-width: 420px;
  padding: 2.5rem;
  width: 100%;
}

.bookingForm_fieldset__r6gez {
  border: none;
  gap: 1.25rem;
  margin: 0;
  padding: 1.25rem;
}

.bookingForm_field__lVYY9 {
  gap: 0.4rem;
  margin: 0;
}

.bookingForm_counterWrapper__Ox5kY .bookingForm_counter__ZSijr {
  gap: 16px;
  justify-content: center;
  margin-bottom: 10px;
}

.bookingForm_counterWrapper__Ox5kY .bookingForm_counter__ZSijr button {
  width: 60px;
}

.bookingForm_label__4gYRH {
  letter-spacing: 0.08em;
}

.bookingForm_input__uD00G {
  background-color: #fafafa;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-sizing: border-box;
  font-size: 1rem;
  outline: none;
  padding: 0.65rem 0.85rem;
  width: 100%;
}

.bookingForm_select__-cmmG {
  appearance: auto;
  cursor: pointer;
}

form > button {
  width: 255px;
}

.bookingForm_inputError__uGzPP {
  border-color: #c0392b;
}

.bookingForm_error__EoH9n {
  color: #c0392b;
}`, "",{"version":3,"sources":["webpack://./src/components/Reservations/BookingForm/bookingForm.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".formWrapper, .counterWrapper .counter {\n  align-items: center;\n}\n\n.counterWrapper, form > button {\n  margin: 0 auto;\n}\n\n.formWrapper {\n  justify-content: center;\n  min-height: 100vh;\n}\n\n.form {\n  background-color: #fff;\n  border-radius: 16px;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);\n  max-width: 420px;\n  padding: 2.5rem;\n  width: 100%;\n}\n\n.fieldset {\n  border: none;\n  gap: 1.25rem;\n  margin: 0;\n  padding: 1.25rem;\n}\n\n.field {\n  gap: 0.4rem;\n  margin: 0;\n}\n\n.counterWrapper .counter {\n  gap: 16px;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.counterWrapper .counter button {\n  width: 60px;\n}\n\n.label {\n  letter-spacing: 0.08em;\n}\n\n.input {\n  background-color: #fafafa;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  box-sizing: border-box;\n  font-size: 1rem;\n  outline: none;\n  padding: 0.65rem 0.85rem;\n  width: 100%;\n}\n\n.select {\n  appearance: auto;\n  cursor: pointer;\n}\n\nform > button {\n  width: 255px;\n}\n\n.inputError {\n  border-color: #c0392b;\n}\n\n.error {\n  color: #c0392b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formWrapper": `bookingForm_formWrapper__SFrsR`,
	"counterWrapper": `bookingForm_counterWrapper__Ox5kY`,
	"counter": `bookingForm_counter__ZSijr`,
	"form": `bookingForm_form__lxVWT`,
	"fieldset": `bookingForm_fieldset__r6gez`,
	"field": `bookingForm_field__lVYY9`,
	"label": `bookingForm_label__4gYRH`,
	"input": `bookingForm_input__uD00G`,
	"select": `bookingForm_select__-cmmG`,
	"inputError": `bookingForm_inputError__uGzPP`,
	"error": `bookingForm_error__EoH9n`
};
export default ___CSS_LOADER_EXPORT___;
